var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.38182 16.3636C6.38182 16.9636 6.86046 17.4545 7.44546 17.4545H22.3364C22.9214 17.4545 23.4 17.9455 23.4 18.5455C23.4 19.1455 22.9214 19.6364 22.3364 19.6364H19.1455V22.9091C19.1455 23.5091 18.6668 24 18.0818 24C17.4968 24 17.0182 23.5091 17.0182 22.9091V19.6364H6.38182C5.21182 19.6364 4.25455 18.6545 4.25455 17.4545V6.54545H1.06364C0.478636 6.54545 0 6.05455 0 5.45455C0 4.85455 0.478636 4.36364 1.06364 4.36364H4.25455V1.09091C4.25455 0.490909 4.73318 0 5.31818 0C5.90318 0 6.38182 0.490909 6.38182 1.09091V16.3636ZM19.1453 15.2715H17.018V7.63514C17.018 7.03514 16.5393 6.54423 15.9543 6.54423H8.50889V4.36241H17.018C18.188 4.36241 19.1453 5.34423 19.1453 6.54423V15.2715Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrop);
export default __webpack_public_path__ + "static/media/crop.eb3ed2b1.svg";
export { ForwardRef as ReactComponent };